import admin from '@/modules/admin';
import sadmin from '@/modules/sadmin';
import main from '@/modules/main';
import client from '@/modules/client';
import booking from '@/modules/booking';

export const modules = [admin, sadmin,main,client,booking];

export function loadModulesLocales() {
    const messages = {};
    for (let i = 0; i < modules.length; i++) {
        const module = modules[i];
        if (typeof module.i18n === 'undefined')
            continue;
        for (const language in module.i18n) {
            typeof messages[language] === "undefined" && (messages[language] = {});
            messages[language][module.name] = module.i18n[language];
        }
    }
    return messages;
}

export function loadStoreModules() {

    const stores = modules.filter(e => e.store);

    var storesObject =  {
        modules: stores.map(e => e.store).reduce((obj, item) => ({...obj, ...item}), {}),

        reducer : stores.map(e => e.store).reduce((obj, item) => ({...obj, ...item}), {})
    }
    console.log('storesObject',storesObject,stores);
    return storesObject;
}

export function loadMenuModules() {
    const datas = modules.filter(e => e.Menu).map(e => e.Menu);
    return {
        drawer: datas.filter(e => e.drawer).map(e => e.drawer).reduce((arr, item) => ([...arr, ...item]), []).sort((a, b) => a.index - b.index),
        appBar: datas.filter(e => e.appBar).map(e => e.appBar).reduce((arr, item) => ([...arr, ...item]), []).sort((a, b) => a.index - b.index)
    }
}

export function loadFilterModules() {
    return modules.filter(e => e.Filters).map(m => ([...m.Filters.map(f => ({
        ...f,
        name: `${m.name}_${f.name}`
    }))])).reduce((arr, item) => ([...arr, ...item]), [])
}
